module.exports = __webpack_public_path__ + "img/firststeps.c6555379.png";